import React, { useEffect, useRef } from 'react'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfScanField } from '../components/RfScanField'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { receivingContext, ReceivingFlowController } from '../flow'
import { ScanForm, TaskHeader } from '../styles'

export const ReceivingLocationScreen = ({
  controller,
  embedded = false,
  onExit,
}: {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}) => {
  const { state, dispatch } = controller
  const form = useRef<HTMLFormElement>(null)
  useEffect(() => {
    if (state.status?.tone === 'error') {
      const input = form.current?.querySelector('input')
      input?.focus()
      input?.select()
    }
  }, [state.status])
  return (
    <RfShell
      title="Receiving"
      phase="Receiving"
      embedded={embedded}
      contextSummary={receivingContext(controller.state)}
      onBack={() => controller.dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="submit" form="receiving-location-form">
          Continue
        </ActionButton>
      }
    >
      <TaskHeader>
        <h1>Scan receiving location</h1>
      </TaskHeader>
      {state.status ? <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner> : null}
      <ScanForm
        ref={form}
        id="receiving-location-form"
        aria-label="Scan receiving location"
        onSubmit={(event) => {
          event.preventDefault()
          dispatch({ type: 'submit-receiving-location' })
        }}
      >
        <RfScanField
          label="Location"
          value={state.locationEntry ?? ''}
          placeholder="Scan or enter location"
          onChange={(value) => dispatch({ type: 'set-receiving-location', value })}
        />
      </ScanForm>
    </RfShell>
  )
}
